import React from 'react';
import {
    IconBrandBluesky,
    IconBrandFacebook,
    IconBrandMessenger,
    IconBrandInstagram,
    IconBrandLinkedin,
    IconBrandPinterest,
    IconBrandTelegram,
    IconBrandWhatsapp,
    IconBrandXing,
    IconMail
} from '@tabler/icons-react';
import { NavLink } from 'react-router-dom';

const shareButton = (props) => {
    let button;
    let utmSource = props.shareType;
    const shareTitle = props.shareTitle;
    const shareText = encodeURIComponent(`Hallo! Unterstütze uns indem du hier für ${shareTitle} abstimmst`);
    const utmParams = `utm_source=${utmSource}&utm_medium=social&utm_campaign=Projektdetailsseite`;
    let shareUrl = window.location.href + (window.location.href.includes('?') ? `&${utmParams}` : `?${utmParams}`);

    switch (props.shareType) {
        case 'email':
            button = (
                <a
                    href={`mailto:?subject=Jetzt für uns abstimmen!&body=${shareText}: ${shareUrl}`}
                    target="_blank"
                    className="anl_social-share--email d-flex align-items-center text-dark text-decoration-none p-1">
                    <IconMail color="#FFC234" size={24} />
                    <span className="ps-2">E-Mail</span>
                </a>
            );
            break;
        case 'facebook':
            button = (
                <a
                    href={`https://www.facebook.com/sharer/sharer.php?u=${shareUrl}`}
                    target="_blank"
                    rel="external noopener"
                    className="anl_social-share--facebook d-flex align-items-center text-dark text-decoration-none p-1">
                    <IconBrandFacebook color="#375797" size={24} />
                    <span className="ps-2">Facebook</span>
                </a>
            );
            break;
        case 'bluesky':
            button = (
                <a
                    href={`https://bsky.app/intent/compose?text=${shareText}%0A%0A${shareUrl}}`}
                    target="_blank"
                    rel="external noopener"
                    className="anl_social-share--bluesky d-flex align-items-center text-dark text-decoration-none p-1">
                    <IconBrandBluesky color="#457CBF" size={24} />
                    <span className="ps-2">Bluesky</span>
                </a>
            );
            break;
        case 'whatsApp':
            button = (
                <a
                    href={`whatsapp://send?text=${shareText}%20${shareUrl}`}
                    target="_blank"
                    className="anl_social-share--whatsapp d-flex align-items-center text-dark text-decoration-none p-1">
                    <IconBrandWhatsapp color="#25D366" size={24} />
                    <span className="ps-2">WhatsApp</span>
                </a>
            );
            break;
        case 'facebookMessenger':
            button = (
                <a
                    href={`fb-messenger://share/?link=${shareUrl}`}
                    target="_blank"
                    className="anl_social-share--messenger d-flex align-items-center text-dark text-decoration-none p-1">
                    <IconBrandMessenger color="#00B2FF" size={24} />
                    <span className="ps-2">Messenger</span>
                </a>
            );
            break;
        case 'telegram':
            button = (
                <a
                    href={`https://t.me/share/url?url=${shareUrl}&text=${shareText}`}
                    target="_blank"
                    className="anl_social-share--telegram d-flex align-items-center text-dark text-decoration-none p-1">
                    <IconBrandTelegram color="#229ED9" size={24} />
                    <span className="ps-2">Telegram</span>
                </a>
            );
            break;
        case 'linkedin':
            button = (
                <a
                    href={`https://www.linkedin.com/sharing/share-offsite/?url=${shareUrl}`}
                    target="_blank"
                    className="anl_social-share--linkedin d-flex align-items-center text-dark text-decoration-none p-1">
                    <IconBrandLinkedin color="#0077B5" size={24} />
                    <span className="ps-2">LinkedIn</span>
                </a>
            );
            break;
        case 'xing':
            button = (
                <a
                    href={`https://www.xing.com/spi/shares/new?url=${shareUrl}`}
                    target="_blank"
                    className="anl_social-share--xing d-flex align-items-center text-dark text-decoration-none p-1">
                    <IconBrandXing color="#126567" size={24} />
                    <span className="ps-2">XING</span>
                </a>
            );
            break;
        case 'pinterest':
            button = (
                <a
                    href={`https://www.pinterest.com/pin/create/bookmarklet/?url=${shareUrl}`}
                    target="_blank"
                    className="anl_social-share--pinterest d-flex align-items-center text-dark text-decoration-none p-1">
                    <IconBrandPinterest color="#e60023" size={24} />
                    <span className="ps-2">Pinterest</span>
                </a>
            );
            break;
        case 'instagram':
            button = (
                <NavLink className={`anl_social-share--instagram d-flex align-items-center text-dark text-decoration-none p-1`} to="../tipps" exact>
                    <IconBrandInstagram color="#dd2a7b" size={24} />
                    <span className="ps-2">Instagram</span>
                </NavLink>
            );
            break;
        default:
            button = (
                <span>Kein Dienst definiert</span>
            );
            break;
    }

    return button;
};

export default shareButton;
